import React from 'react';
import { List, Avatar,Pagination} from 'antd';
import cbhead from "../../assets/images/cbhead.jpg";
import Axios from 'axios';
import '../../assets/css/list.css';
import {Redirect}from 'react-router-dom';

class VideoList extends React.Component{

    state={
      name:"",
      //domain:'http://10.0.7.102:3005',
      domain:"",
      regionIdMd:"",
      data:[],
      regionId:"",
      regionName:"",
      userId:"",
      total:7,
      current:1,
      size:7,
      videoEditFlag:false,
      itemId:"",
      xrFlag:false
  }
     onShowSizeChange = (current, size)=> {
        if(current===""||current===undefined||size===""||size===undefined){
          current=this.state.current
          size=this.state.size
        }
        //分页
        var  params = new URLSearchParams();
        var api =this.state.domain+"/switch/video/select";
        let cbId = localStorage.getItem("cbId");
        params.append("adminId",this.state.userId);
        params.append("type","0");
        params.append("videoType","1");
        params.append("treasureId",cbId); 
        params.append("pageNumer",current);
        params.append("pageSize",size);

        Axios.post(api,params)
        .then((res)=>{
            if(res.data.status===1){
              this.setState({
                data:res.data.list,
                total:res.data.total,
                current:current,
                size,size
            })
            }else if(res.data.status===2){
              alert("登录失效!")
              window.location.href='/'
            }else{
              console.log(res.data.message)
            }
       })
      .catch((error)=>{
          console.log(error)
      })   
  }

   delete = (itemId)=>{
        
        var  params = new URLSearchParams();
        var api =this.state.domain+"/switch/video/delete";
        params.append("id",itemId);
        Axios.post(api,params)
        .then((res)=>{
          this.onShowSizeChange();
       })
      .catch((error)=>{
          console.log(error)
      }) 
  }

     componentDidMount(){
      //登录人ID
      let userId = localStorage.getItem("userId");
      //村宝id
      let cbId = localStorage.getItem("cbId");
      let regionId = localStorage.getItem("regionId");
      let regionName = localStorage.getItem("regionName");
      let countyId = localStorage.getItem("countyId");
      let countyName = localStorage.getItem("countyName");
      //调用后台获取区域内村宝信息
      var  params = new URLSearchParams();
      var api =this.state.domain+"/switch/video/select";
      params.append("type","0");
      params.append("videoType","1");
      params.append("treasureId",cbId); 
      params.append("pageNumer",1);
      params.append("pageSize",7);
      Axios.post(api,params)
      .then((res)=>{ 
          if(res.data.status===1){
            this.setState({
              data:res.data.list,
              userId:userId,
              cbId:cbId,
              regionId:regionId,
              regionName:regionName, 
              total:res.data.total,
              countyId:countyId,
              countyName:countyName
          })
          }else if(res.data.status===2){
            alert("登录失效!")
            window.location.href='/'
          }else{
            console.log(res.data.message)
          }
     })
    .catch((error)=>{
        console.log(error)
    })

  } 

  //编辑
  videoEdit=(data)=>{
     //视频封面链接
     localStorage.setItem("photo",data.videoUrl);
    //视频跳转链接
     localStorage.setItem("videoUrl",data.videoLink);
     //视频名字
     localStorage.setItem("videoName",data.name);
     //s视频标签
     localStorage.setItem("vLable",data.tag);
     //村宝ID
    localStorage.setItem("cbId",data.treasureId);
    //视频id
    localStorage.setItem("videoId",data.id);
    //开始时间
    localStorage.setItem("startTime",data.startTime);
      //视频id
      localStorage.setItem("id",data.id);
     this.setState({
      videoEditFlag:true,
      itemId:data.id
     })
  }
    render(){
      if(this.state.videoEditFlag){
        return <Redirect to={{pathname: `/news/videoAdd/${this.state.itemId}`} }/>;
      };
    return(
          <div>
            <div>
             <img style={{width:'100%'}} src={cbhead} alt="村宝头部"/>
            </div>
            <List
                itemLayout="horizontal"
                dataSource={this.state.data}
                renderItem={item => (
                <List.Item  actions={[
                  localStorage.getItem("regionId")==="0"?
                    <a onClick={ (e) => this.videoEdit(item)} key="list-loadmore-videoAdd">预览</a>:
                    <a  onClick={ (e) => this.videoEdit(item)} key="list-loadmore-videoAdd">编辑</a>,
                    <a onClick={ (e) => this.delete(item.id)} key="list-loadmore-delete">删除</a>]}>
                    <List.Item.Meta
                    avatar={<Avatar src={`${item.videoUrl}?x-oss-process=style/cunbaoTouxiang`}/>}
                    title={item.name}
                    description= {<a href={item.videoLink} target="_blank">{item.videoLink}</a>}
                    />
               </List.Item>
            )}      
        />
          <br/><br/>
          <Pagination onChange={this.onShowSizeChange} defaultCurrent={1} defaultPageSize={7} total={this.state.total}/>
          </div>
      )
    }
  }
  
  export default VideoList;


// WEBPACK FOOTER //
// ./src/components/Model/VideoList.js